import { PageType } from "shared/lib/page-type";

export const pathname = "/plus/agenda";

export const page = {
  route(
    query: QueryParameters<{
      articleId?: string;
      entityId?: string;
      nodeId?: string;
      startDate?: string;
    }>,
  ) {
    return { pathname, query: { ...query, pageType: PageType.Plus } };
  },
};
